import { pageconfigurationsApi } from 'app/src/services/welfareportal/'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const getTutorialPageConfig = http.get<object, DefaultBodyType, pageconfigurationsApi.Page>(
  apiBaseUrl + '/:templateId/pages/tutorial',
  () => {
    return HttpResponse.json([
      {
        id: 'tutorialpage',
        sections: [
          {
            renderingMode: 'native',
            sectionName: 'TutorialInformativeSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'TutorialHowToSection',
          },
          // {
          //   renderingMode: 'native',
          //   sectionName: 'TutorialVideoCarouselSection',
          // },
          {
            renderingMode: 'native',
            sectionName: 'TutorialMoreInfoSection',
          },
        ],
      },
    ])
  },
)

export const tutorialPageConfigHandlers = [getTutorialPageConfig]
